module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-policy"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Entity")]), _c('span', [_vm._v(_vm._s(_vm.item.sentinellable) + " " + _vm._s(_vm.item.sentinellable_id))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Content")]), _c('span', [_vm._v(_vm._s(_vm.item.content))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Severity")]), _c('span', [_vm._v(_vm._s(_vm.severity))])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Date and Time")]), _c('span', [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.timestamp, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]), _c('div', {
    staticClass: "column"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: _vm.item.sentinellable.toLowerCase(),
        params: {
          id: _vm.item.sentinellable_id
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43655c1b!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Sentinel.vue
// module id = 2450
// module chunks = 1